import { InstallSpec, ItemComponent } from "@p0security/shared/install/types";

/**
 * One item per AWS account, keyed by the account ID. The account must also
 * have AWS IAM management and AWS OIDC federation installed: P0 reaches AWS
 * through the first, and grants through the second's role pool.
 */
export const DynamoDbAiComponents = InstallSpec({
  "iam-write": ItemComponent({
    description:
      "Lets agents request access to DynamoDB tables in this AWS account. The account must have AWS IAM management and AWS OIDC federation installed.",
    label: "IAM management",
    maturity: "beta",
    schema: {},
    type: "dynamic",
  }),
});
